import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetReferralsParams,
	GetReferralsModel,
} from 'domain/usecases/private/my-referrals-flow/get-referrals';
import {GetReferralsList} from './referral-list';

export class RemoteGeReferralsList implements GetReferralsList {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetReferralsModel>,
	) {}

	async get({signal, ...params}: GetReferralsParams): Promise<GetReferralsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;

			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
